import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-row-layout',
  templateUrl: './row-layout.component.html',
  styleUrls: ['./row-layout.component.scss']
})
export class RowLayoutComponent implements OnInit {

  @Input() rowData: any;
  @Input() rowStyle: any;

  constructor() { }

  ngOnInit(): void {
  }

}
